import { SearchSvg } from 'assets/svg-icon';
import classNames from 'classnames';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { setOpenSidebar } from 'redux/reducers/app/reducer';
import { getSidebar } from 'redux/reducers/app/selectors';
import { getUserData } from 'redux/reducers/auth/selectors';
import { SvgBigSidebar, SvgSmallSidebar } from 'ui/svg-image/SvgSidebar';
import './Sidebar.scss';
import { listLinksSidebar } from './sidebarData';

const normalizePath = (path: string) => {
  if (!path) return '/';
  return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
};

const normalizeSegment = (path: string) => {
  return normalizePath(path).split('/').filter(Boolean)[0] || '';
};

const isSidebarLinkActive = (pathname: string, linkPath: string, linksName?: string) => {
  const currentPath = normalizePath(pathname);
  const targetPath = normalizePath(linkPath);

  if (currentPath === targetPath || currentPath.startsWith(`${targetPath}/`)) {
    return true;
  }

  if (!linksName) return false;

  const currentFirstSegment = normalizeSegment(currentPath);
  const linkFirstSegment = normalizeSegment(linksName);

  return currentFirstSegment === linkFirstSegment;
};

export const Sidebar: FC = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(getUserData);
  const [open, setOpen] = useState(false);
  const sidebar = useSelector(getSidebar);

  const onCloseSidebar = () => {
    dispatch(setOpenSidebar(true));
  };

  return (
    <div
      className={classNames('sidebar', {
        'sidebar-phone': sidebar,
        'minimized-custom': open,
      })}
    >
      <div className="sidebar-top">
        <button onClick={() => setOpen(!open)} type="button" className="sidebar__action">
          {!open ? <SvgSmallSidebar /> : <SvgBigSidebar />}
        </button>

        <nav className="sidebar-nav">
          <ul className="sidebar-nav__list">
            <div className="input input-custom input-search input-opacity-mob">
              <div className="input-wrapper">
                <input
                  className="input-item input-item--left-icon"
                  type="text"
                  name="search"
                  placeholder="Search"
                />
                <span className="input-icon">
                  <SearchSvg />
                </span>
              </div>
            </div>

            {listLinksSidebar.map((link) =>
              link.role.includes(user?.role?.toLowerCase() as string) ? (
                <li key={link.id}>
                  <Link
                    onClick={onCloseSidebar}
                    to={link.link}
                    className={classNames({
                      active: isSidebarLinkActive(pathname, link.link, link.links_name),
                    })}
                  >
                    <span className="sidebar-nav-icon">
                      <link.svg />
                    </span>
                    {!open && <span className="sidebar-nav-text">{link.linkName}</span>}
                  </Link>
                </li>
              ) : null,
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};
